import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getAuthToken } from '../../authToken';

const RedirectionComplement = () => {
    const navigate = useNavigate();
    const user_id = localStorage.getItem('user_id');
    const [formData, setFormData] = useState(null); // Initialisé à null
    const [isLoading, setIsLoading] = useState(true);
    const [shouldRedirect, setShouldRedirect] = useState(false);

    // Fonction pour récupérer les informations de l'utilisateur
const fetchUtilisateur = async () => {
    try {
        const token = localStorage.getItem('access_token');

        const response = await fetch(`${process.env.REACT_APP_HOTE}/recup-info-profil/${user_id}/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        });

        if (!response.ok) {
            throw new Error(`Erreur HTTP: ${response.status}`);
        }

        const data = await response.json();
        setFormData(data);
        
        // Vérifier immédiatement si les données requises sont présentes
        const requiredDataMissing = !data?.tel || 
                                  !data?.profession || 
                                  !data?.type_financement;
        
        setShouldRedirect(requiredDataMissing);
    } catch (error) {
        console.error('Erreur lors de la récupération des données utilisateur', error);
        // En cas d'erreur, considérer qu'une redirection est nécessaire
        setShouldRedirect(true);
    } finally {
        setIsLoading(false);
    }
};

    useEffect(() => {
        if (!user_id) {
            navigate('/');
            return;
        }
        
        fetchUtilisateur();
    }, [user_id, navigate]);

    useEffect(() => {
        if (!isLoading && shouldRedirect) {
            navigate('/profil-utilisateur');
        }
    }, [isLoading, shouldRedirect, formData, navigate, user_id]);

    // Pendant le chargement, afficher un indicateur
    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Chargement...</span>
                </div>
            </div>
        );
    }

    // Si aucune redirection n'est nécessaire et que le chargement est terminé
    // Vous pouvez retourner null ou un composant vide
    return null;
};

export default RedirectionComplement;